import { render, staticRenderFns } from "./status-pictogram-form.vue?vue&type=template&id=bd8b0b3e&scoped=true"
import script from "./status-pictogram-form.vue?vue&type=script&lang=js"
export * from "./status-pictogram-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd8b0b3e",
  null
  
)

export default component.exports